/**
 * Firebase Configuration
 * Contains credentials for Pyxida Firebase project
 */

export const FIREBASE_CONFIG = {
  apiKey: "AIzaSyA-ZoLrIZy10-lsoxo4m3SL9zRI1oTaoTI",
  authDomain: "pyxida-e6211.firebaseapp.com",
  databaseURL: "https://pyxida-e6211-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "pyxida-e6211",
  storageBucket: "pyxida-e6211.appspot.com",
  messagingSenderId: "953737634109",
  appId: "1:953737634109:web:ff1ba3bda52a99a6336554",
  measurementId: "G-K7TQDJBLNV",
};

export default FIREBASE_CONFIG;
